import { showInfoLayerAction as showInfoLayerActionTyre } from '../../_flux/actions/catalog_configurator_actions';
import { showInfoLayerAction as showInfoLayerActionRego } from '../../_flux/actions/rego_lookup_actions';
import { showInfoLayerAction as showInfoLayerActionVehicle } from '../../_flux/actions/vehicle_configurator_actions';
import CONFIGURATOR_TYPES from '../../_flux/constants/configurator_types';
import { setDispatcher } from '../../_flux/actions/last_used_configurator_actions';

export function onShowInfoClick(type) {
  let configuratorType = CONFIGURATOR_TYPES.CATALOG_CONFIGURATOR;
  let showInfoLayerActionFn = null;
  if (type === 'rego') {
    configuratorType = CONFIGURATOR_TYPES.REGO_LOOKUP;
    showInfoLayerActionFn = showInfoLayerActionRego;
  } else if (type === 'vehicle') {
    configuratorType = CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR;
    showInfoLayerActionFn = showInfoLayerActionVehicle;
  } else {
    showInfoLayerActionFn = showInfoLayerActionTyre;
  }
  setDispatcher(configuratorType);
  showInfoLayerActionFn();
}
